import Swiper from 'swiper';
import {Navigation, Thumbs} from 'swiper/modules';
import './modules/common';
import './modules/tabs';
import './modules/product-sticky';
import './modules/viewed';
import {Fancybox} from "@fancyapps/ui";

/**
 *  Свайпер превью товара
 */
const productGalleryBreakpoint = window.matchMedia('(min-width: 992px)');

const getProductThumbsOptions = () => {
    return productGalleryBreakpoint.matches
        ? {direction: 'vertical', spaceBetween: 8}
        : {direction: 'horizontal', spaceBetween: 14};
};

const updateProductThumbsDisabledState = (swiper) => {
    swiper.el.parentElement.classList.toggle('_disabled', swiper.isLocked);
};

const productThumbsOptions = getProductThumbsOptions();

let productThumbsSwiper = new Swiper('#productThumbsSwiper', {
    modules: [Navigation],
    direction: productThumbsOptions.direction,
    slidesPerView: 'auto',
    spaceBetween: productThumbsOptions.spaceBetween,
    grabCursor: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: '.productThumbsSwiper__button_next',
        prevEl: '.productThumbsSwiper__button_prev',
    },
    on: {
        init: function () {
            updateProductThumbsDisabledState(this);
        },
        resize: function () {
            updateProductThumbsDisabledState(this);
        },
    },
});

const updateProductThumbsLayout = () => {
    const options = getProductThumbsOptions();

    productThumbsSwiper.params.spaceBetween = options.spaceBetween;
    productThumbsSwiper.changeDirection(options.direction, false);
    productThumbsSwiper.update();
    updateProductThumbsDisabledState(productThumbsSwiper);
};

if (productGalleryBreakpoint.addEventListener) {
    productGalleryBreakpoint.addEventListener('change', updateProductThumbsLayout);
} else {
    productGalleryBreakpoint.addListener(updateProductThumbsLayout);
}

/**
 *  Свайпер товара
 */
let productPhotoSwiper = new Swiper('#productPhotoSwiper', {
    modules: [Navigation, Thumbs],
    slidesPerView: 1,
    spaceBetween: 10,
    grabCursor: true,
    thumbs: {
        swiper: productThumbsSwiper,
    },
    navigation: {
        nextEl: '.productPhotoSwiper__button_next',
        prevEl: '.productPhotoSwiper__button_prev',
    },
});

document.addEventListener(
    "DOMContentLoaded", () => {
        Fancybox.bind('#showRequestForm', {
            compact: true,
            defaultType: 'inline',
        });
    }
)
